import * as React from 'react';
import LoginActions from './account_actions';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { i18n } from 'arm-common';

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Logout.jsx] "
        this.back = this.back.bind(this);
        this.state = {};
    }

    back() {
        this.props.history.push("login");
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        this.props.logout().then(
            resolve => {
                console.log("[Logout.jsx] logout -> resolve");
            },
            reject => {
                console.log("[Logout.jsx] logout -> reject");
            }
        );

    }

    render() {
        console.log('[logout] Logout- new React');

        return <div className="container justify-content-center mt-3" style={{ width: '500px' }}>
            <agui.aCard>
                <agui.aCardHeader >
                    <h3 className="panel-title">{i18n('V2.LOGOUT.CARD_TIT.USER_LOGGED_OUT', 'USER LOGGED OUT')}</h3>
                </agui.aCardHeader>
                <agui.aCardBody>
                    <form>
                        <div className="panel-body pl-3">
                            <p>{i18n("V2.LOGOUT.MESS_LOG.SESSION_HAS_BEEN_CLOSED.", "La sessione è stata chiusa.")}</p>
                            <p>{i18n("V2.LOGOUT.MESS_LOG.TO_WORK_ON_THE_APPLICATION", "Per tornare sull'applicazione clicca sul bottone \"home\"")}</p>
                        </div>
                    </form>
                </agui.aCardBody>
                <agui.aCardFooter>
                    <a href="" onClick={this.back} className="btn btn-primary"  >{i18n('V2.LOGOUT.BUTTON_TIT_LOG.HOME', 'HOME')}</a>
                </agui.aCardFooter>
            </agui.aCard>
        </div>
    }
}


const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(LoginActions.logout()),
});

export default connect(null, mapDispatchToProps)(Logout);